export const environment = {
  production: true,
  apiUrl: 'https://eapply-demo-api.ysoft.gr/api/v1/',
  productSchoolId: 1,
  baseUrl: 'https://eapply-demo.ysoft.gr',
  version: '1.0.0'
};
